import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { Trend, TrendFamily } from '@lib/ProAPI/pro-api.types';
import { RedirectContext, StateContext } from '@store/store';
import Image from 'next/image';
import React, { useContext, useMemo, useState } from 'react';

const TrendCard = ({
  trend,
  isMuted,
  toggleMute,
}: {
  trend: Trend;
  isMuted: boolean;
  toggleMute: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const [isHovered, _setIsHovered] = useState(true);
  const { goToAiSignup } = useContext(RedirectContext);
  const { platform } = useContext(StateContext);

  const assetsUrl = process.env.NEXT_PUBLIC_EDITOR_CDN_URL;

  const isDesktop = platform === PlatformType.Desktop;

  const handleTrendClick = () => {
    goToAiSignup({
      ux_source: 'Trends',
      nextUrl: `/agents-models?trend=${trend.id}`,
    });
  };

  return (
    <div
      key={trend.id}
      className={ivclass(
        'iv-flex iv-flex-col iv-gap-12 iv-w-[168px] iv-h-[278px] iv-relative',
      )}
      onClick={handleTrendClick}
      // onMouseEnter={() => setIsHovered(true)}
      // onMouseLeave={() => setIsHovered(false)}
      // onFocus={() => setIsHovered(true)}
      // onBlur={() => setIsHovered(false)}
    >
      {isDesktop && isHovered ? (
        <button
          onClick={toggleMute}
          className={ivclass(
            'iv-absolute iv-top-[10px] iv-left-[10px]',
            'iv-opacity-30 hover:iv-opacity-100',
            'iv-bg-grey-0',
            'iv-border-solid iv-border-grey-85',
            'iv-rounded-full',
            'iv-w-[25px] iv-h-[25px]',
            'iv-flex iv-items-center iv-justify-center',
            'iv-shadow-md',
            'iv-cursor-pointer',
            'iv-transition-all iv-duration-500 iv-ease-in-out',
            'hover:iv-scale-100',
          )}
          style={{
            border: '5px solid rgba(133, 133, 133, 0.2)',
            zIndex: 100,
          }}
          onMouseOver={e => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.transform = 'scale(1)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.opacity = '0.3';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          {isMuted ? (
            <Image
              width={20}
              height={20}
              src={
                assetsUrl +
                '/dark/panels/top-panel/component-props/selected/volume-mute.svg'
              }
              alt="Mute"
            />
          ) : (
            <Image
              width={20}
              height={20}
              src={
                assetsUrl +
                '/dark/panels/top-panel/component-props/selected/volume.svg'
              }
              alt="Unmute"
            />
          )}
        </button>
      ) : null}
      {trend.preview_url && isHovered ? (
        <video
          src={trend.preview_url}
          poster={trend.thumbnail_url}
          className={ivclass(
            'iv-w-full iv-h-full iv-min-h-[240px] iv-rounded-16 iv-object-cover',
          )}
          autoPlay
          muted={isMuted}
          loop
          playsInline
        />
      ) : (
        <ImageComponent
          elementype="native"
          src={trend.thumbnail_url}
          alt={trend.display_name}
          className={ivclass(
            'iv-w-full iv-h-full iv-min-h-[240px] iv-rounded-16 iv-object-cover',
          )}
        />
      )}
      <span className={ivclass('iv-text-body-xl iv-text-left iv-text-grey-95')}>
        {trend.display_name}
      </span>
    </div>
  );
};

function TrendsFamilyListing({
  trendsFamily,
}: {
  trendsFamily: TrendFamily[];
}) {
  const [isMuted, setIsMuted] = useState(true);

  const trends = useMemo(() => {
    return trendsFamily
      .flatMap(family => family.trends)
      .sort((a, b) => a.index - b.index);
  }, [trendsFamily]);

  const toggleMute = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsMuted(!isMuted);
  };

  return (
    <div
      className={ivclass(
        'iv-relative iv-overflow-x-hidden',
        'iv-flex iv-flex-wrap iv-gap-x-15 iv-gap-y-20',
        'iv-py-20 iv-px-60 md:iv-px-25 sm:iv-px-35',
        'iv-w-full iv-h-full',
      )}
    >
      {trends.map(trend => (
        <TrendCard
          trend={trend}
          key={trend.id}
          isMuted={isMuted}
          toggleMute={toggleMute}
        />
      ))}
    </div>
  );
}

export default TrendsFamilyListing;
